export default __webpack_public_path__ + "images/walmart_image1.svg";